const SCI_CLS = {
  "Protocollo definito": "bg-zinc-100 text-zinc-700 border-zinc-200",
  "In verifica": "bg-amber-50 text-amber-800 border-amber-200",
  "Validazione completata": "bg-emerald-50 text-emerald-800 border-emerald-200",
};

export const sciStatus = (t) => t?.verification_status || "Protocollo definito";

export function ProtocolStatusBadges({ test: t }) {
  const s = sciStatus(t);
  return (
    <div className="flex flex-wrap gap-1 mt-1" data-testid={`test-status-${t.id}`}>
      <span data-testid={`test-sci-status-${t.id}`} title="Stato scientifico" className={`text-[10px] px-1.5 py-0.5 rounded border ${SCI_CLS[s] || SCI_CLS["Protocollo definito"]}`}>Scientifico: {s}</span>
      <span data-testid={`test-dt-approval-${t.id}`} title="Approvazione tecnica della Direzione Tecnica (separata dalla validazione scientifica)" className={`text-[10px] px-1.5 py-0.5 rounded border ${t.technical_approval ? "bg-blue-50 text-blue-800 border-blue-200" : "bg-white text-zinc-500 border-zinc-200"}`}>{t.technical_approval ? "Approvato DT" : "Non approvato DT"}</span>
    </div>
  );
}

export function ProtocolVersionHistory({ test: t, testid }) {
  const list = t?.protocol_versions || [];
  if (!list.length) return null;
  return (
    <details data-testid={testid || `test-versions-${t.id}`} className="mt-1 text-[10px] text-zinc-500">
      <summary className="cursor-pointer hover:text-black">Storico versioni ({list.length} precedenti · attuale v{t.protocol_version || 1})</summary>
      <ul className="mt-1 space-y-0.5 font-mono">
        {[...list].reverse().map((v) => (
          <li key={v.protocol_version}>v{v.protocol_version} · {(v.valid_from || "").slice(0, 10) || "—"} → {(v.archived_at || "").slice(0, 10)} · {v.verification_status || "Protocollo definito"}{v.technical_approval ? " · approvato DT" : ""} · {v.attempts} tent.</li>
        ))}
      </ul>
    </details>
  );
}
